import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import AdminLayout from "../views/admin/AdminLayout.vue";
import ProductsManagement from "../views/admin/ProductsManagement.vue";
import ContactsManagement from "../views/admin/ContactsManagement.vue";
import AdminLogin from "../views/admin/AdminLogin.vue";
import store from "../store";

const routes = [
  { path: "/admin/login", component: AdminLogin },
  {
    path: "/admin",
    component: AdminLayout,
    meta: { requiresAuth: true },
    redirect: "/admin/products",
    children: [
      { path: "products", component: ProductsManagement },
      { path: "contacts", component: ContactsManagement },
    ],
  },
  { path: "/", name: "Home", component: Home },
  { path: "/about", name: "About", component: () => import("../views/About.vue") },
  { path: "/products", name: "Products", component: () => import("../views/Products.vue") },
  { path: "/contact", name: "Contact", component: () => import("../views/Contact.vue") },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !store.getters["admin/isAuthenticated"]) {
    next("/admin/login");
  } else {
    next();
  }
});

export default router;
